import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { FC, ReactNode } from 'react';
import { Card } from '../../../../../../components/card/card';
import { Table } from '../../../../../../features/table/table';
import { useLang } from '../../../../../../hooks/use-lang';
import s from './reviews-widget.module.css';

interface Props {
  className: string;
  label: string;
  type: 'negative' | 'neutral' | 'positive';
  isExpanded: boolean;
  rows?: Record<string, ReactNode>[];
  count?: number;
}

export const ReviewsWidget: FC<Props> = (props) => {
  const { className, label, rows, type, isExpanded, count } = props;
  const { t } = useLang();

  return (
    <Card className={cn(s.feature, className)}>
      <div className={s.header}>
        <h3 className={cn(s.label, s[type])}>{label}</h3>

        <span>{count}</span>
      </div>

      <AnimatePresence initial={false}>
        {isExpanded && (
          <motion.div
            key="table"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: '400px', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ type: 'tween' }}
          >
            <Table
              className={s.table}
              rows={rows}
              onEmpty={{
                title: t('Список отзывов пуст'),
                text: t('Дождитесь, пока ваши клиенты оставят отзывы'),
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Card>
  );
};
